import React from "react";

import Col from "antd/es/col";
import Row from "antd/es/row";
import Space from "antd/es/space";
import { useIntl } from "react-intl";

import { EntityTypesSupportedByIntegrations } from "@mapmycustomers/shared/types/entity";

import TextWithInfo from "@app/component/typography/TextWithInfo";
import TextWithLine from "@app/component/typography/TextWithLine";
import layout from "@app/styles/layout";
import Integration from "@app/types/integrations/Integration";

import IntegrationCard from "../IntegrationCard";
import ObjectSyncSettings from "../ObjectSyncSettings";

import styles from "./Steps.module.scss";

interface Props {
  onSyncOptionChange: (
    entityType: EntityTypesSupportedByIntegrations,
    incoming: boolean,
    outgoing: boolean
  ) => void;
  supportedEntityTypes: EntityTypesSupportedByIntegrations[];
  syncOptions: Integration["syncOptions"];
}

const EntitySyncSettings: React.FC<Props> = ({
  onSyncOptionChange,
  supportedEntityTypes,
  syncOptions,
}) => {
  const intl = useIntl();
  return (
    <div>
      <TextWithLine>
        <TextWithInfo
          info={intl.formatMessage({
            id: "integrations.setupStep.selectRecordType.tooltip",
            defaultMessage: "Toggle to select the record types you would like to sync",
            description: "Select record types information",
          })}
        >
          {intl.formatMessage({
            id: "integrations.setupStep.selectRecordType",
            defaultMessage: "Select record types",
            description: "Select record types text",
          })}
        </TextWithInfo>
      </TextWithLine>
      <Space className={styles.blockSpace} direction="vertical" size="large">
        <IntegrationCard padded>
          <Row gutter={[layout.spacerL, layout.spacerL]}>
            {supportedEntityTypes.map((entityType) => (
              <Col key={entityType} sm={{ span: 8 }} xl={{ span: 24 }}>
                <ObjectSyncSettings
                  entityType={entityType}
                  incoming={syncOptions[entityType].incoming}
                  key={entityType}
                  onChange={onSyncOptionChange}
                  outgoing={syncOptions[entityType].outgoing}
                />
              </Col>
            ))}
          </Row>
        </IntegrationCard>
      </Space>
    </div>
  );
};

export default EntitySyncSettings;
